import UserRewardItem from '@activities/MainActivity/components/UserRewards/UserRewardItem';
import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import useProject from '@hooks/useProject';
import BarcodeIcon from '@icons/BarcodeIcon';
import CouponIcon from '@icons/CouponIcon';
import StampIcon from '@icons/StampIcon';
import { useTranslation } from 'react-i18next';

function UserRewards() {
    const { t } = useTranslation('main', { keyPrefix: 'rewards' });
    const project = useProject();
    return (
        <Column spacing={16} css={css`
            padding: 0 20px;;
        `}>
            <Text color={colors.gray8} fontWeight='bold' size='xl'>
                {t('userName', { name: project?.name })}
            </Text>
            <Container>
                <UserRewardItem icon={StampIcon}
                    label={t('stamp')}
                    content='8'
                />
                <UserRewardItem icon={CouponIcon}
                    label={t('coupon')}
                    content={t('couponCount', { couponCount: 3 })} />
                <UserRewardItem icon={BarcodeIcon}
                    label={t('barcode')}
                    content={t('membership')} />
            </Container>
        </Column>
    );
}

const Container = styled.div`
    background-color: ${colors.gray1};
    border-radius: 8px;
    padding: 0 8px;
    width: 100%;
    margin-bottom: 28px;
    display: flex;
`;

export default UserRewards;
